<script setup>
import { reactive } from 'vue';

let props = defineProps({
    link: {
        type: String,
        required: false,
    },
    type: {
        type: String,
        required: true,
        validator(value) {
            return ['blue', 'purple'].includes(
                value
            );
        },
    },
});
let divClasses = reactive({
    blue: 'from-wgn-blue-3 to-wgn-blue-4 bg-gradient-90 rounded-md px-4 py-2.5 text-white text-base font-bold',
    purple: 'mx-auto wgn-purple-5 bg-gray-500 border-rounded-md rounded-md py-[9px] text-center',
});
</script>

<template>
    <Link :href="props.link" v-if="link"
          class=""
          :class="divClasses[props.type]"
    >
        <slot />
    </Link>
    <div v-else
        class=""
        :class="divClasses[props.type]"
    >
        <slot />
    </div>
</template>
